import React, { memo } from 'react'

import { Checkbox, RadioButton, Tooltip } from '@fourthwall/components'

import type { ProductsListItemProps } from '../ProductsListItem/ProductsListItem.types'
import * as S from './ProductsListItemInput.styled'

type ProductsListItemInputProps = Omit<ProductsListItemProps, 'mode'>

export const ProductsListItemInput = memo(
  ({
    multiple,
    selectMode,
    item,
    value,
    disabled,
    onSelect,
    onBulkSelect,
    disabledMessage,
  }: ProductsListItemInputProps) => {
    const getInput = () => {
      if (multiple) {
        const isBulkSelect = selectMode === 'VARIANTS' && item.type === 'OFFER'

        return (
          <Checkbox
            id={item.id}
            value={value}
            onValueChange={isBulkSelect ? onBulkSelect(item.variantsIds) : onSelect(item.id)}
            indeterminate={isBulkSelect}
            disabled={disabled}
          />
        )
      }

      if (selectMode === 'VARIANTS' && item.type === 'OFFER') {
        return <S.InputSpacing />
      }

      return (
        <S.RadioButtonWrapper>
          <RadioButton value={value as string} checkedValue={item.id} disabled={disabled} />
        </S.RadioButtonWrapper>
      )
    }

    const input = getInput()

    return disabledMessage ? <Tooltip reference={input}>{disabledMessage}</Tooltip> : input
  },
)
